import classnames from 'classnames';

import {Headline} from 'components/atoms/Text/Headline';
import {MainGrid} from 'components/atoms/Layout/MainGrid';
import {BlogItem, BlogItemType} from 'components/organisms/ContentBlocks/BlogItem';
import * as React from 'react';

import {BlogItemPageViewModel} from 'features/template/viewModels/BlogItemPage';

import './style.scss';
import { useDeviceStore, selectIsMobile } from 'features/ui/store/useDeviceStore';
import { HeadlineLevel } from 'features/ui/enums';

interface Props {
    blogItems: BlogItemPageViewModel[];
    headline?: string;
    blogListUrl?: string;
    id?: string;
}

export const BlogGrid: React.FunctionComponent<Props> = ({blogItems, headline, blogListUrl: _blogListUrl, id}) => {
    const isMobile = useDeviceStore(selectIsMobile);
    const numberOfBlogs = [...new Set(blogItems.map(x => x.parentName))];
    const multiFeed = numberOfBlogs.length > 1;
    const numberOfItems = 3 + (isMobile ? 0 : 1) + (multiFeed ? 1 : 0);
    const gridClasses = classnames('blog blog-grid', {
        'blog--single': blogItems.length < (multiFeed ? 3 : 2),
        'blog--multi-feed': multiFeed,
        'blog--single-feed': !multiFeed,
    });

    console.log(numberOfItems);

    return (
        <MainGrid fullwidth className={gridClasses} id={id}>
            {headline && blogItems && blogItems.length > 0 && 
                <Headline 
                    level={HeadlineLevel.H2} 
                    center 
                    className="blog__headline" 
                >
                    {headline}
                </Headline>
            }
            <ul className='blog__list'>
                {blogItems.slice(0, numberOfItems).map((blogItem, i) => {
                    return (
                        <BlogItem 
                            key={i} 
                            parentName={blogItem.parentName}
                            image={blogItem.heroImage}
                            link={blogItem.url}
                            date={blogItem.date}
                            headline={blogItem.title}
                            text={blogItem.introText}
                            singleFeed={!multiFeed} 
                            itemType={i > (multiFeed ? 1 : 0)
                                ? BlogItemType.GRIDSMALL
                                : multiFeed
                                    ? BlogItemType.GRIDMEDIUM
                                    : BlogItemType.GRIDLARGE
                            } 
                        />
                    )
                })}
            </ul>
        </MainGrid>
    )
};
